import { BFF_BASE_URL } from "../../../api/client";

/**
 * Opens the funding-fax PDF for the given approval in a new browser tab
 * (GET /api/v1/workbench/{appId}/funding-fax/pdf). Like the deal-summary PDF, the
 * browser fetches and renders it directly; auth rides on the same-origin session cookie.
 * @param {string} approvalId - The approval/deal ID.
 */
export function printFundingFax(approvalId: string): void {
  const url = `${BFF_BASE_URL}/api/v1/workbench/${encodeURIComponent(approvalId)}/funding-fax/pdf`;
  window.open(url, "_blank");
}
